import { mapToBreakpoints } from './mapToBreakpoints.js';

/**
 * Get CSS declaration for some color, optionally for particular breakpoint(s)
 * @param {string|object} values Color token, optionally for a given breakpoint (e.g. 'primary10' or {m: 'primary10'})
 * @param {string} prop Which CSS property to use (e.g. background-color)
 * @returns {string} CSS declaration for the desired color / breaking point
 */
const getColor = (values, prop = 'background-color') => ({
  theme
}) => {
  return mapToBreakpoints(values, value => {
    return `
        ${prop}: ${theme.designTokens.colors[value]};
      `;
  });
};

export { getColor };
//# sourceMappingURL=getColor.js.map
